import React from 'react';
import { ShieldAlert, CheckCircle, Handshake, MessageCircle, RefreshCw, Award } from 'lucide-react';
const guarantees = [{
  icon: DollarSign,
  promise: 'Solo $25 por tu demo',
  meaning: 'Es todo lo que arriesgas para ver tu website real'
}, {
  icon: Eye,
  promise: 'Si no te gusta, ahí termina',
  meaning: 'Solo se te cobra el demo, sin compromiso'
}, {
  icon: RefreshCw,
  promise: 'Revisiones incluidas',
  meaning: 'No paramos hasta que lo ames'
}, {
  icon: Handshake,
  promise: 'Proceso transparente',
  meaning: 'Sabes exactamente qué está pasando en cada etapa'
}, {
  icon: MessageCircle,
  promise: 'Comunicación directa por WhatsApp',
  meaning: 'Respuestas rápidas, sin intermediarios'
}, {
  icon: ShieldAlert,
  promise: 'Sin mensualidades forzadas',
  meaning: 'Pagas el mantenimiento solo si lo quieres'
}];
// Need to import DollarSign and Eye since I used them in the array
import { DollarSign, Eye } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-24 bg-dark relative" data-id="element-158" data-mp="20su4t51kers2">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-159" data-mp="20s2k4p9iaegk">
        <div className="text-center mb-16" data-id="element-160" data-mp="1vt7q0r6393h5">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/10 mb-6" data-id="element-161" data-mp="1vu9bzqon7adn">
            <ShieldAlert className="w-8 h-8 text-gold" data-id="element-162" data-mp="1rtyv3izbazk0" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-163" data-mp="2ohdenp09jcm9">
            Cero Riesgo. 100% Satisfacción. <br className="hidden md:block" data-id="element-164" data-mp="2jkmvutx2q2x5" />
            <span className="text-gold" data-id="element-165" data-mp="2eslp1niod4ei">O Lo Corregimos.</span>
          </h2>
          <div className="text-lg text-gray-400 max-w-2xl mx-auto space-y-4" data-id="element-166" data-mp="2eqio48fzhqv0">
            <p data-id="element-167" data-mp="2aqibmtcg3pql">Sabemos que probablemente te han fallado antes.</p>
            <p data-id="element-168" data-mp="379ftcutcgitv">
              Tal vez alguien te hizo un website que no se parecía en nada a lo
              que querías. Tal vez pagaste y nunca viste resultados.
            </p>
            <p className="text-white font-bold" data-id="element-169" data-mp="10kxf7un62twb">Así no operamos nosotros.</p>
          </div>

          <div className="mt-10 max-w-3xl mx-auto bg-dark-100 border border-gold/30 rounded-2xl p-6 md:p-8" data-id="element-170" data-mp="15jqspn2gekwh">
            <div className="inline-flex items-center gap-2 text-gold text-xs font-bold uppercase tracking-wider mb-3" data-id="element-171" data-mp="qv422p7dm6py">
              <Award className="w-4 h-4" data-id="element-172" data-mp="vt5ljb8ps81y" />
              Confiamos en nuestro trabajo
            </div>
            <p className="text-lg md:text-xl text-white font-medium leading-relaxed" data-id="element-173" data-mp="ht4ltz46r6o2">
              Estamos tan seguros de la calidad de lo que hacemos que{' '}
              <span className="text-gold" data-id="element-174" data-mp="7vzy3uuoz355">
                sabemos que tu página te va a encantar
              </span>
              . Por eso te dejamos verla antes de pagarla completa — no
              necesitamos convencerte con palabras, te lo demostramos con tu
              propio website.
            </p>
          </div>
        </div>

        <div className="bg-dark-100 rounded-3xl border border-white/10 p-8 md:p-12 shadow-2xl" data-id="element-175" data-mp="2781c9vkmxzyv">
          <h3 className="text-2xl font-bold text-center text-white mb-10" data-id="element-176" data-mp="3rs6esy1r7a2j">
            Nuestra Garantía:
          </h3>

          <div className="grid md:grid-cols-2 gap-x-12 gap-y-8" data-id="element-177" data-mp="3mtmtmzuzi2b8">
            {guarantees.map((item, index) => <div key={index} className="flex items-start gap-4" data-id="element-178" data-mp="5dn1l4oim0xn" data-mpi={index}>
                <div className="bg-dark p-3 rounded-xl border border-white/5 shrink-0" data-id="element-179" data-mp="k20h3rmkqu8">
                  <item.icon className="w-6 h-6 text-gold" data-id="element-180" data-mp="eb74sj5xu7aw" />
                </div>
                <div data-id="element-181" data-mp="ab6h07wy8jr6">
                  <h4 className="text-white font-bold mb-1" data-id="element-182" data-mp="a9lnmlmdf6uw">{item.promise}</h4>
                  <p className="text-gray-400 text-sm" data-id="element-183" data-mp="oaxxqgeuoe8v">{item.meaning}</p>
                </div>
              </div>)}
          </div>

          <div className="mt-12 pt-8 border-t border-white/10 text-center" data-id="element-184" data-mp="jc4l0q7e0r9r">
            <p className="text-xl font-bold text-white" data-id="element-185" data-mp="2q2kja2fz3gxy">
              Pagas el resto solo si tu demo te{' '}
              <span className="text-gold" data-id="element-186" data-mp="2l498nphut2eo">encanta</span>. Si no, solo pagaste
              los $25.
            </p>
          </div>
        </div>
      </div>
    </section>;
}